import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import GerbangPage from "@/pages/GerbangPage";
import GateInPage from "@/pages/GateInPage";
import GateOutPage from "@/pages/GateOutPage";
import LogKendaraanPage from "@/pages/LogKendaraanPage";
import ReceivingPage from "@/pages/ReceivingPage";
import ReceivingTimelinePage from "@/pages/ReceivingTimelinePage";
import DeliveryPage from "@/pages/DeliveryPage";
import DeliveryTimelinePage from "@/pages/DeliveryTimelinePage";
import WeighPage from "@/pages/WeighPage";
import LoadingProcessPage from "@/pages/LoadingProcessPage";
import StockOpnamePage from "@/pages/StockOpnamePage";
import UserManagementPage from "@/pages/UserManagementPage";
import StorageMaintenancePage from "@/pages/StorageMaintenancePage";
import ApprovalCenterPage from "@/pages/ApprovalCenterPage";
import CustomerManagementPage from "@/pages/CustomerManagementPage";
import StockSummaryPage from "@/pages/StockSummaryPage";
import ApprovalHistoryPage from "@/pages/ApprovalHistoryPage";
import DailyReportPage from "@/pages/DailyReportPage";
import PeriodReportPage from "@/pages/PeriodReportPage";
import HistoryPage from "@/pages/HistoryPage";
import TankStockPage from "@/pages/TankStockPage";
import EditLogPage from "@/pages/EditLogPage";
import SPBPrintPage from "@/pages/SPBPrintPage";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            <Route path="/gerbang" element={<ProtectedRoute><GerbangPage /></ProtectedRoute>} />
            <Route path="/gate-in" element={<Navigate to="/gerbang?tab=in" replace />} />
            <Route path="/gate-out" element={<Navigate to="/gerbang?tab=out" replace />} />
            <Route path="/log-kendaraan" element={<ProtectedRoute><LogKendaraanPage /></ProtectedRoute>} />
            <Route path="/receiving" element={<ProtectedRoute><ReceivingPage /></ProtectedRoute>} />
            <Route path="/receiving/timeline" element={<ProtectedRoute roles={["admin", "owner", "admin_kantor", "supervisor", "inventory"]}><ReceivingTimelinePage /></ProtectedRoute>} />
            <Route path="/delivery" element={<ProtectedRoute><DeliveryPage /></ProtectedRoute>} />
            <Route path="/delivery/timeline" element={<ProtectedRoute roles={["admin", "owner", "admin_kantor", "supervisor"]}><DeliveryTimelinePage /></ProtectedRoute>} />
            <Route path="/weigh-in" element={<ProtectedRoute><WeighPage direction="in" /></ProtectedRoute>} />
            <Route path="/weigh-out" element={<ProtectedRoute><WeighPage direction="out" /></ProtectedRoute>} />
            <Route path="/loading" element={<ProtectedRoute><LoadingProcessPage /></ProtectedRoute>} />
            <Route path="/opname" element={<ProtectedRoute><StockOpnamePage /></ProtectedRoute>} />
            <Route path="/tank-stock" element={<ProtectedRoute><TankStockPage /></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute><UserManagementPage /></ProtectedRoute>} />
            <Route path="/admin/storage" element={<ProtectedRoute roles={["admin", "owner"]}><StorageMaintenancePage /></ProtectedRoute>} />
            <Route path="/approval" element={<ProtectedRoute><ApprovalCenterPage /></ProtectedRoute>} />
            <Route path="/customers" element={<ProtectedRoute><CustomerManagementPage /></ProtectedRoute>} />
            <Route path="/stock" element={<ProtectedRoute><StockSummaryPage /></ProtectedRoute>} />
            <Route path="/approval-history" element={<ProtectedRoute><ApprovalHistoryPage /></ProtectedRoute>} />
            <Route path="/reports/daily" element={<ProtectedRoute><DailyReportPage /></ProtectedRoute>} />
            <Route path="/reports/period" element={<ProtectedRoute roles={["admin", "owner", "admin_kantor"]}><PeriodReportPage /></ProtectedRoute>} />
            <Route path="/history" element={<ProtectedRoute roles={["admin", "owner", "admin_kantor"]}><HistoryPage /></ProtectedRoute>} />
            <Route path="/edit-logs" element={<ProtectedRoute roles={["admin", "owner"]}><EditLogPage /></ProtectedRoute>} />
            <Route path="/spb/:id" element={<ProtectedRoute roles={["admin", "owner", "admin_kantor", "admin_pabrik", "supervisor"]}><SPBPrintPage /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
